
import { defineComponent, ref, onMounted } from "vue";
import { Actions } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import type { ElForm } from "element-plus";

type FormInstance = InstanceType<typeof ElForm>;

export default defineComponent({
  setup() {
    onMounted(() => {
      if (!route.params.id) {
        setCurrentPageBreadcrumbs("新增签", ["抽签签池;lottery_signs"]);
      } else {
        setCurrentPageBreadcrumbs("编辑签", [
          "抽签签池;lottery_signs",
          route.params.id.toString(),
        ]);
      }
    });

    const rules = ref({
      name: [
        {
          required: true,
          message: "签名称不可为空",
          trigger: "change",
        },
      ],
      point: [
        {
          required: true,
          message: "会员积分不可为空",
          trigger: "change",
        },
        {
          type: "number",
          min: 0,
          message: "会员积分须 ≥ 0",
          trigger: "change",
        },
      ],
      weight: [
        {
          required: true,
          message: "权重不可为空",
          trigger: "change",
        },
        {
          type: "number",
          min: 1,
          message: "权重须 ≥ 1",
          trigger: "change",
        },
      ],
    });

    const formRef = ref<FormInstance>();
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const lottery_sign = ref({
      name: "",
      poem: "",
      point: 0,
      weight: 1,
      sorting: 0,
      enabled: true,
    } as any);

    const onCancel = () => {
      router.push({ name: "lottery_signs" });
    };

    const isNew = !route.params.id;

    const onSubmit = (formEl: FormInstance | undefined) => {
      if (!formEl) return;

      formEl.validate((valid) => {
        if (valid) {
          if (isNew) {
            store
              .dispatch(Actions.CREATE_LOTTERY_SIGN, lottery_sign.value)
              .then(() => {
                router.push({ name: "lottery_signs" });
              })
              .catch((errorMsg) => {
                Swal.fire({
                  text: errorMsg || "操作失败",
                  icon: "error",
                  confirmButtonText: "确认",
                });
              });
          } else {
            store
              .dispatch(Actions.UPDATE_LOTTERY_SIGN, {
                id: route.params.id,
                values: lottery_sign.value,
              })
              .then(() => {
                router.push({ name: "lottery_signs" });
              })
              .catch((errorMsg) => {
                Swal.fire({
                  text: errorMsg || "操作失败",
                  icon: "error",
                  confirmButtonText: "确认",
                });
              });
          }
        } else {
          return false;
        }
      });
    };

    if (!isNew) {
      store
        .dispatch(Actions.GET_LOTTERY_SIGN, route.params.id)
        .then(() => {
          lottery_sign.value = store.getters.currentLotterySign;
        })
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        .catch(() => {});
    }

    return {
      onSubmit,
      lottery_sign,
      rules,
      onCancel,
      formRef,
    };
  },
});
